// Front.js
'use strict';

const calc = new Calculator();
let image = new Image;

if (calc.isCanvasReady('canvas')) {
	calc.setCanvas('canvas');
	calc.setContext();
	calc.trackTransforms();

	image.src = '/assets/images/houses/default.jpg';
	image.onload = function () {
		calc.redraw();
		// console.log('Redraw');
	};
}

$(function () {
	if ($('body').hasClass('calculator')) {
		/*
		$(document).on("click", "button#refresh", function () {
			if (typeof localStorage !== 'undefined') {
				localStorage.removeItem('components');
			}
		});

		// Restore components position
		if (typeof localStorage !== 'undefined') {
			const components = localStorage.getItem('components');

			if (null !== components) {
				$("#gates-wickets").html(components);
			}
		}
		*/

		calc.allowSortable();

		$(document).on("click", "a.btn.disabled", function (e) {
			return false;
		});

		$(document).on("click", "a.image-change", function () {
			const myImage = new Image;
			myImage.src = '/assets/images/houses/house-16.jpg';
			myImage.onload = function () {
				calc.redraw();
				// console.log('Redraw');
			};
			 // console.log('Changed');

			calc.setImage(myImage);

			calc.showControls();
			calc.showComponents();

			return false;
		});

		// ********************************************************************************************************************************************************
		// First step
		$(document).on("click", ".steps__select.steps__select-house a.btn.select-house", function () {
			calc.showOnlyOneStep(1);

			let $parent = $(this).parents('.steps__select');
			calc.showStepExtra($parent);

			return false;
		});

		$(document).on("click", ".steps__select.steps__select-house a.btn.close", function () {
			let $parent = $(this).parents('.steps__select');
			calc.showStepDefault($parent);

			calc.enableStep(2);
			calc.showAllSteps();

			return false;
		});

		$(document).on("click", ".steps__select.steps__select-house a.house-change", function () {
			const url = '/assets/images/houses/' + $(this).data('house') + '.jpg';

			$.get(url)
				.done(function () {
					const myImage = new Image;
					myImage.src = url;
					myImage.onload = function () {
						calc.redraw();
					};
					// console.log('Changed');

					calc.setImage(myImage);

					calc.showControls();
					calc.showComponents();
				}).fail(function () {
				console.error('File ' + url + ' not exists!');
			});

			return false;
		});

		// ********************************************************************************************************************************************************
		// Second step
		$(document).on("click", ".steps__select.steps__select-fence a.btn.select-fence", function () {
			calc.showOnlyOneStep(2);

			let $parent = $(this).parents('.steps__select');
			calc.showStepExtra($parent);

			return false;
		});

		$(document).on("click", ".steps__select.steps__select-fence a.btn.close", function () {
			let $parent = $(this).parents('.steps__select');
			calc.showStepDefault($parent);

			calc.enableStep(3);
			calc.showAllSteps();

			return false;
		});

		$(document).on("click", ".steps__select.steps__select-fence a.fence-change", function () {
			return false;
		});

		// ********************************************************************************************************************************************************
		// Third step
		$(document).on("click", ".steps__select.steps__select-sides a.btn.add-side", function () {
			calc.showOnlyOneStep(3);

			let $parent = $(this).parents('.steps__select');
			calc.showStepExtra($parent);

			return false;
		});

		$(document).on("click", ".steps__select.steps__select-sides a.btn.close", function () {
			let $parent = $(this).parents('.steps__select');
			calc.showStepDefault($parent);

			calc.showAllSteps();

			return false;
		});
	}
});

$(window).on('load', function () {
	if ($('body').hasClass('calculator')) {
		// console.log('Canvas load');

		calc.setImage(image);

		$(document).on("click", ".control-btn.control-zoom-in", function () {
			calc.zoom(1);
			// console.log('Zoom in');
			return false;
		});

		$(document).on("click", ".control-btn.control-zoom-out", function () {
			calc.zoom(-1);
			// console.log('Zoom out');
			return false;
		});

		$(document).on("click", ".control-btn.control-move", function () {
			calc.move($(this).data('x'), $(this).data('y'));
			// console.log('Move');
			return false;
		});

		calc.redraw();
	}
});

$(function () {
	$.nette.init();

	$.nette.ext('webona', {
		success: function (payload, status, xhr, settings) {
			// console.log(payload);

			// Restore components position
			let $stepsWrapper = $('#steps');

			if ($stepsWrapper.length) {
				if (typeof localStorage !== 'undefined') {
					const scrollPosition = localStorage.getItem('scrollPosition');

					if (null !== scrollPosition) {
						setTimeout(function() {
							$stepsWrapper.scrollTop(parseInt(scrollPosition));
						}, 100);
					}
				}
			}

			$("#fences").show();
			if ($("#desks").hasClass('active')) {
				$("#desks").show();
			}
			$("#columns").show();
			$("#gates-wickets li.move-disabled").removeClass('disabled-during-move');
			calc.showComponents();

			calc.allowSortable();

			if (payload.step) {
				let $parent = $('#steps .steps__select.step-' + payload.step);

				if ($parent.length) {
					calc.showOnlyOneStep(payload.step);
					calc.showStepExtra($parent);
				}
			}

			if (payload.house) {
				const url = '/houses/' + payload.house;

				$.get(url)
					.done(function () {
						const myImage = new Image;
						myImage.src = url;
						myImage.onload = function () {
							calc.redraw();
						};
						// console.log('Changed');

						calc.setImage(myImage);

						calc.showControls();
						calc.showComponents();
					}).fail(function () {
					console.error('File ' + url + ' not exists!');
				});
			}

			if (payload.flashMessages) {
				setTimeout(function() {
					$("div.flash").fadeOut(500);
				}, 2000);
			}

			// history.pushState({}, null, window.currentUri);
		}
	}, {state: null});


	$.nette.ext('spinner', {
		start: function (xhr, settings) {
			var $placeholder = this.getPlaceholder(settings);
			var spinner = this;
			settings.spinnerQueue = settings.spinnerQueue || [];

			// console.log('Spin');

			if ($placeholder.length) {
				$placeholder.each(function() {
					var i = settings.spinnerQueue.push($(spinner.spinnerHtml));
					$(this).append(settings.spinnerQueue[i-1]);

					// console.log('Spin append');
				});
			}
		},
		complete: function (xhr, status, settings) {
			if (! ('forceRedirect' in xhr) && ! ('forceReload' in xhr) && 'spinnerQueue' in settings) {
				var l = settings.spinnerQueue.length;
				for (var i = 0; i < l; i++) {
					settings.spinnerQueue[i].remove();
				}
			}
		}
	}, {
		spinnerHtml: '<div class="ajax-overlay"></div><div class="ajax-loader"></div>',
		getPlaceholder: function(settings) {
			var $placeholder = $();

			if (settings.nette) {
				var $el = settings.nette.el;
				$placeholder = this.getElementPlaceholder($el);

			} else if (settings.spinner) {
				$placeholder = $(settings.spinner);
			}

			return $placeholder;
		},
		getElementPlaceholder: function($el) {
			var $placeholder = $();
			var $wrap = null;

			if($el.is('[data-no-spinner]'))
				return $placeholder;

			$placeholder = $($el.data('spinner'));

			if ($placeholder.length === 0 && ($wrap = $el.closest('.ajax-wrap')).length) {
				if (($placeholder = $wrap.find('.ajax-spinner')).length === 0) {
					$placeholder = $wrap;
				}
			}

			return $placeholder;
		}
	});

	$(document).on("change", "div#steps form.ajax", function (e) {
		let $target = $(e.target);

		// Do nothing if length is initiator and no height is selected
		if ($target.is('input[name^=length]')) {
			let $parent = $target.parent();

			if ($parent.length) {
				let $height = $parent.find('select[name^=height] option:selected');

				if ($height.length && ("" === $height.val())) {
					return false;
				}
			}
		}

		let $step = $target.closest('.steps__select');

		let $stepsWrapper = $('#steps');

		if ($stepsWrapper.length) {
			if (typeof localStorage !== 'undefined') {
				localStorage.setItem('scrollPosition', $stepsWrapper.scrollTop());
			}
		}

		if ($step.length) {
			$step.find("input[type=submit]").trigger('click');
		} else {
			// Fallback
			$(this).closest("form").find("input[type=submit]").trigger('click');
		}

		return false;
	});

	jQuery(document).on('click', 'a.scroll-to-anchor', function (e) {
		e.preventDefault();
		const anchor = jQuery(jQuery(this).attr('href'));
		if (anchor.length) {
			jQuery("html, body").animate({scrollTop: anchor.offset().top}, 1000);
		}
		return false;
	});

	jQuery(document).on('click', 'a.scroll-to-class', function (e) {
		e.preventDefault();
		const target = jQuery('.' + jQuery(this).data('class'));

		if (target.length) {
			jQuery("html, body").animate({scrollTop: target.offset().top}, 1000);
		}
		return false;
	});

	jQuery(document).on('click', 'a.scroll-to-selector', function (e) {
		e.preventDefault();
		const target = jQuery(jQuery(this).data('selector'));

		if (target.length) {
			jQuery("html, body").animate({scrollTop: target.offset().top}, 1000);
		}
		return false;
	});
});
